import { data } from '../../svg/Expand/data';
import { makeIcon } from '../makeIcon';

export const Expand = makeIcon(data, 'expand', 'Expand');

export default Expand;
